var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('img',{staticClass:"sticker-static",attrs:{"src":'https://stickershop.line-scdn.net/stickershop/v1/sticker/'+_vm.data+'/PC/sticker.png'}})])}
var staticRenderFns = []

export { render, staticRenderFns }